import type { ScoProduct } from '@src/graphql-types'

import { productCanContinue } from './presentation'

export type ConversionDecision = {
  gateState: 'guest' | 'locked' | 'entitled'
  nextStep: 'none' | 'join' | 'purchase' | 'upgrade' | 'unavailable'
}

/** The caller resolves domain permissions and proration eligibility; this never reads the session. */
export function resolveConversionDecision(args: {
  isGuest: boolean
  isEntitled: boolean
  canProrateUpgrade?: boolean
  product?: ScoProduct | null
}): ConversionDecision {
  if (args.isEntitled) {
    return { gateState: 'entitled', nextStep: 'none' }
  }
  if (args.isGuest) {
    return { gateState: 'guest', nextStep: 'join' }
  }
  if (!args.product || !productCanContinue(args.product)) {
    return { gateState: 'locked', nextStep: 'unavailable' }
  }
  return {
    gateState: 'locked',
    nextStep: args.canProrateUpgrade ? 'upgrade' : 'purchase',
  }
}

export type ConversionOfferSelection = {
  productId: string
  termId?: string
  couponCode?: string
}

/** Carries the exact resolved product, term, and applied code to the caller's quote flow. */
export function selectionFromProduct(product: ScoProduct): ConversionOfferSelection | null {
  if (!productCanContinue(product)) {
    return null
  }
  return {
    productId: product.productId,
    termId: product.effectiveTermId || product.termId || undefined,
    couponCode: product.appliedCoupon?.code || undefined,
  }
}
